import React from 'react'
import { cn } from 'cn'

export type Props = {
  children: React.ReactNode
  className?: string
}

export default function FieldError({ children, className }: Props) {
  if (!children) return null

  return (
    <p className={cn('text-sm italic text-red-500 font-light mt-1', className)}>
      {children}
    </p>
  )
}
